import { render, staticRenderFns } from "./UserNavigationSidebar.vue?vue&type=template&id=3c55d663&scoped=true"
import script from "./UserNavigationSidebar.vue?vue&type=script&lang=js"
export * from "./UserNavigationSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserNavigationSidebar.vue?vue&type=style&index=0&id=3c55d663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55d663",
  null
  
)

export default component.exports